import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../assets/pmlogo.png'; // Update with your actual path

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.querySelector('.header').classList.add('fade-in');
  }, []);

  return (
    <header className="header sticky">
      <div className="logo-container">
        <img src={logo} alt="ProMaster Logo" className="logo" />
      </div>

      <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
        <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
        <Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link>
        <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
      </nav>

      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
        <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
        <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
      </div>
    </header>
  );
}

export default Header;
// Make sure to create a Header.css file with the necessary styles